module.exports = __webpack_public_path__ + "static/buehne_leistungen-5bf4ccc218d07a6806866222eb7dac88.svg";